'use strict';

require('./curry.js');
require('./isString-d8679d99.js');
require('./flatten-a717674f.js');
require('./variadic.js');
var compose = require('./compose.js');
require('./_append.js');
require('./append.js');
require('./flip.js');
var concatWith = require('./concatWith-aa95abaf.js');
var isArray = require('./isArray-fff5bad6.js');
var mempty = require('./mempty-fb137ec7.js');
var concat = require('./concat.js');

/**
 * Flattens any strings in the list of `as`.
 *
 * @private
 */

function flattenStrings(as) {
  if (mempty.isArrayOfStrings(as)) {
    return concat(as);
  } else if (isArray.isArray(as)) {
    return as.map(flattenStrings);
  } else {
    return as;
  }
}

function concatMap(f, as) {
  var bs = Array.from(as).map(compose(flattenStrings, f));
  var cs = bs.length > 0 ? bs : as;
  return concatWith.concatWith(mempty.mempty(cs), bs);
}

module.exports = concatMap;
